import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {AuthService} from '../auth.service';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';


import {map, switchMap, tap, catchError, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';

// import 'rxjs/Rx';

import * as AuthActions from './auth.actions';
import * as ErrorActions from '../../error/store/error.actions';
import * as UserActions from '../../user/store/user.actions';
import {HttpErrorResponse} from '@angular/common/http';
import {TokenModel} from '../token.model';
import {Cookie} from '../../helper/cookie';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class AuthEffects {

  authSignin = createEffect(() => this.actions$
    .pipe(
      ofType(AuthActions.TRY_SIGNIN),
      map(
      (action: AuthActions.TrySignin) => {
          return action.payload;
        }
      ),
      switchMap(
        (actionData: {email: string, password: string}) => {
          return this.authService.login(
            actionData.email,
            actionData.password
          ).pipe(
            mergeMap(
              (response: TokenModel) => {
                this.router.navigate(['/']);
                return [
                  {
                    type: AuthActions.SIGNIN
                  },
                  {
                    type: AuthActions.SET_TOKEN,
                    payload: {
                      token: response.token,
                      exp: response.exp,
                      id: response.id
                    }
                  },
                  {
                    type: UserActions.GET_ACTUAL_USER
                  }
                ];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.notifierService.error('Wrong email or password. Please try again.');
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  authSigninByUid = createEffect(() => this.actions$
    .pipe(
      ofType(AuthActions.TRY_SINGIN_BY_UID),
      map(
        (action: AuthActions.TrySinginByUid) => {
          return action.payload;
        }
      ),
      switchMap(
        (actionData: {userUid: string, withRedirect: boolean}) => {
          return this.authService.loginByUid(
            actionData.userUid
          ).pipe(
            mergeMap(
              (response: TokenModel) => {
                if (actionData.withRedirect) {
                  this.router.navigate(['/']);
                }
                return [
                  {
                    type: AuthActions.SIGNIN
                  },
                  {
                    type: AuthActions.SET_TOKEN,
                    payload: {
                      token: response.token,
                      exp: response.exp,
                      id: response.id
                    }
                  },
                  {
                    type: UserActions.GET_ACTUAL_USER
                  }
                ];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.notifierService.error('Wrong email or password. Please try again.');
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  authSigninByFacebook = createEffect(() => this.actions$
    .pipe(
      ofType(AuthActions.TRY_SIGNUP_BY_FACEBOOK),
      map(
        (action: AuthActions.TrySingupByFacebook) => {
          return action.payload;
        }
      ),
      switchMap(
        (actionData: {accessToken: string, params: any}) => {
          return this.authService.loginByFacebook(
            actionData.accessToken,
            actionData.params
          ).pipe(
            mergeMap(
              (response: TokenModel) => {
                this.notifierService.success('Data has been saved correctly');

                if (actionData.params.redirectAfterSave) {
                  let url = ['/'];
                  if (actionData.params.redirectUrl !== undefined) {
                    url = actionData.params.redirectUrl;
                  }
                  this.router.navigate(url);
                }
                return [
                  {
                    type: AuthActions.SIGNIN
                  },
                  {
                    type: AuthActions.SET_TOKEN,
                    payload: {
                      token: response.token,
                      exp: response.exp,
                      id: response.id
                    }
                  },
                  {
                    type: UserActions.GET_ACTUAL_USER
                  }
                ];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.notifierService.error('Wrong email or password. Please try again.');
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  authSigninByGoogle = createEffect(() => this.actions$
    .pipe(
      ofType(AuthActions.TRY_SIGNUP_BY_GOOGLE),
      map(
        (action: AuthActions.TrySingupByGoogle) => {
          return action.payload;
        }
      ),
      switchMap(
        (actionData: {accessToken: string, params: any}) => {
          return this.authService.loginByGoogle(
            actionData.accessToken,
            actionData.params
          ).pipe(
            mergeMap(
              (response: TokenModel) => {
                this.notifierService.success('Data has been saved correctly');

                if (actionData.params.redirectAfterSave) {
                  let url = ['/'];
                  if (actionData.params.redirectUrl !== undefined) {
                    url = actionData.params.redirectUrl;
                  }
                  this.router.navigate(url);
                }
                return [
                  {
                    type: AuthActions.SIGNIN
                  },
                  {
                    type: AuthActions.SET_TOKEN,
                    payload: {
                      token: response.token,
                      exp: response.exp,
                      id: response.id
                    }
                  },
                  {
                    type: UserActions.GET_ACTUAL_USER
                  }
                ];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.notifierService.error('Wrong email or password. Please try again.');
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  authLogout = createEffect(() => this.actions$
    .pipe(
      ofType(AuthActions.LOGOUT),
      tap(
        () => {
          // this.router.navigate(['/signin']);
          setTimeout(() => {
            window.location.href = environment.mainPage;
          }, 1000);
          const cookie = new Cookie();
          cookie.removeCookie('auditor-token');
          cookie.removeCookie('auditor-token-expiry');
          cookie.removeCookie('auditor-user-id');
        }
      )
    ), {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
    private notifierService: ToastrService

  ) {}
}
